import { Route, Routes } from 'react-router';
import LoginPage from '@preview/pages/LoginPage';

const Unauthenticated = () => {
  return (
    <Routes>
      <Route element={<LoginPage />} index />
      <Route element={<LoginPage />} path="*" />
    </Routes>
  );
};

export default Unauthenticated;
